var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-8 gmap_canvas"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"id":"gmap_canvas","src":_vm.srcMap,"width":"100%","height":"400px","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }